(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beneficios-emo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(wrapper) {
      var elementos = wrapper.querySelectorAll('.qsf-anim');
      if (!elementos.length) return;
      if (!('IntersectionObserver' in window)) {
        elementos.forEach(function (el) { el.classList.add('qsf-visible'); });
        return;
      }
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('qsf-visible'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });
      elementos.forEach(function (el) { obs.observe(el); });
    }
    function init() { document.querySelectorAll('.qsf-wrapper').forEach(iniciar); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beneficios-prod"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(wrapper) {
      var elementos = wrapper.querySelectorAll('.beneb-fs-anim');
      if (!elementos.length) return;

      if (!('IntersectionObserver' in window)) {
        elementos.forEach(function (el) { el.classList.add('beneb-fs-visible'); });
        return;
      }

      var observer = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            entrada.target.classList.add('beneb-fs-visible');
            observer.unobserve(entrada.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });

      elementos.forEach(function (el) { observer.observe(el); });
    }

    function init() {
      document.querySelectorAll('.beneb-fs-wrapper').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calcu-envio"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.envio-banner').forEach(function (banner, indice) {
    var idFechas = banner.querySelector('.envio-fecha');
    var idCiudad = banner.querySelector('.envio-ciudad');
    var idCount = banner.querySelector('.envio-timer span');

    // ===== Dias de entrega segun pais (detectado por IP) =====
    // AR: minimo 20 dias | UY: 11 a 12 dias | otros: 5 a 7 dias habiles
    var ENTREGA = {
      AR: { desde: 20, hasta: 23 },
      UY: { desde: 11, hasta: 12 }
    };

    function sumarDias(fecha, dias) {
      var resultado = new Date(fecha);
      resultado.setDate(resultado.getDate() + dias);
      return resultado;
    }
    function sumarDiasHabiles(fecha, dias) {
      var resultado = new Date(fecha);
      var agregados = 0;
      while (agregados < dias) {
        resultado.setDate(resultado.getDate() + 1);
        var dia = resultado.getDay();
        if (dia !== 0 && dia !== 6) agregados++;
      }
      return resultado;
    }
    var meses = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    var diasSemana = ['dom','lun','mar','mié','jue','vie','sáb'];
    function formatearFecha(fecha) {
      return diasSemana[fecha.getDay()] + ', ' + fecha.getDate() + ' ' + meses[fecha.getMonth()];
    }

    var hoy = new Date();
    var paisTienda = (banner.getAttribute('data-pais') || '').toUpperCase();
    var listo = false;

    function mostrar(pais, ciudad) {
      if (listo) return;
      listo = true;
      pais = (pais || '').toUpperCase();
      var desde, hasta;
      if (ENTREGA[pais]) {
        desde = sumarDias(hoy, ENTREGA[pais].desde);
        hasta = sumarDias(hoy, ENTREGA[pais].hasta);
      } else {
        desde = sumarDiasHabiles(hoy, 5);
        hasta = sumarDiasHabiles(hoy, 7);
      }
      if (idFechas) {
        idFechas.innerHTML = 'Llega entre el <strong>' + formatearFecha(desde) + ' – ' + formatearFecha(hasta) + '</strong>';
      }
      if (idCiudad) {
        idCiudad.textContent = ciudad ? 'Envío gratis a ' + ciudad : 'Envío gratis a tu domicilio';
      }
    }

    // Respaldo: deteccion de pais de Shopify y, si falla, el pais de la tienda
    function respaldo() {
      if (listo) return;
      fetch('/browsing_context_suggestions.json')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
          mostrar(c || paisTienda, null);
        })
        .catch(function () { mostrar(paisTienda, null); });
    }

    var fuentes = [
      { url: 'https://get.geojs.io/v1/ip/geo.json', pais: 'country_code', ciudad: 'city' },
      { url: 'https://ipwho.is/', pais: 'country_code', ciudad: 'city' },
      { url: 'https://free.freeipapi.com/api/json', pais: 'countryCode', ciudad: 'cityName' },
      { url: 'https://ipapi.co/json/', pais: 'country_code', ciudad: 'city' }
    ];
    function probar(i) {
      if (listo) return;
      if (i >= fuentes.length) { respaldo(); return; }
      var f = fuentes[i];
      var ctrl = window.AbortController ? new AbortController() : null;
      var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 2500);
      fetch(f.url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) {
          clearTimeout(t);
          var pais = d && d[f.pais];
          var ciudad = d && d[f.ciudad];
          if (!pais || !ciudad) { probar(i + 1); return; }
          mostrar(pais, ciudad);
        })
        .catch(function () { clearTimeout(t); probar(i + 1); });
    }
    probar(0);
    setTimeout(respaldo, 9000);

    var horas = parseInt(banner.getAttribute('data-horas'), 10) || 0;
    var minutos = parseInt(banner.getAttribute('data-minutos'), 10) || 0;
    var segundos = parseInt(banner.getAttribute('data-segundos'), 10) || 0;
    var totalMs = ((horas * 3600) + (minutos * 60) + segundos) * 1000;

    function actualizarCountdown() {
      if (!idCount || totalMs <= 0) return;
      var ahora = new Date().getTime();
      var restante = totalMs - (ahora % totalMs);
      var h = Math.floor(restante / 3600000);
      var m = Math.floor((restante % 3600000) / 60000);
      var s = Math.floor((restante % 60000) / 1000);
      idCount.textContent =
        String(h).padStart(2,'0') + ':' +
        String(m).padStart(2,'0') + ':' +
        String(s).padStart(2,'0');
    }
    actualizarCountdown();
    setInterval(actualizarCountdown, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-prod"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(wrapper) {
      var viewport = wrapper.querySelector('.uing-viewport');
      var pista = wrapper.querySelector('.uing-pista');
      if (!viewport || !pista) return;
      var tarjetas = pista.querySelectorAll('.uing-tarjeta');
      if (tarjetas.length < 3) return;

      var loopOn = wrapper.dataset.loop === 'true';
      var originales = Math.max(1, Math.round(tarjetas.length / 3));

      // Suavidad del deslizamiento: mas alto = mas lento y suave.
      var suav = parseFloat(wrapper.dataset.suavidad);
      if (isNaN(suav)) suav = 7;
      var lerp = 0.05 + (10 - suav) * 0.02;
      if (lerp < 0.03) lerp = 0.03;
      if (lerp > 0.30) lerp = 0.30;

      var puntosWrap = wrapper.querySelector('.uing-puntos');
      var puntos = wrapper.querySelectorAll('.uing-punto');
      var idxActual = -1;

      var step = 0, setW = 0;
      var pos = 0, target = 0;
      var dragging = false, down = false;
      var startX = 0, startY = 0, startPos = 0, movido = 0, bloquear = false;
      var pausado = false;

      function medir() {
        var estilo = getComputedStyle(pista);
        var gap = parseFloat(estilo.columnGap || estilo.gap) || 0;
        step = tarjetas[0].offsetWidth + gap;
        setW = step * originales;
      }

      function activo() {
        return loopOn && setW > viewport.clientWidth + 4;
      }

      function baseOff() {
        return activo() ? setW : 0;
      }

      function aplicar() {
        pista.style.transform = 'translate3d(' + (-pos) + 'px,0,0)';
      }

      function envolver() {
        if (!activo()) return;
        while (pos >= setW * 2) { pos -= setW; target -= setW; }
        while (pos < setW) { pos += setW; target += setW; }
      }

      function pintarPuntos() {
        if (!puntos.length || step === 0) return;
        var raw = Math.round((pos - baseOff()) / step);
        var i = ((raw % originales) + originales) % originales;
        if (i === idxActual) return;
        idxActual = i;
        for (var k = 0; k < puntos.length; k++) {
          if (k === i) {
            puntos[k].classList.add('uing-punto--activo');
            puntos[k].setAttribute('aria-current', 'true');
          } else {
            puntos[k].classList.remove('uing-punto--activo');
            puntos[k].removeAttribute('aria-current');
          }
        }
      }

      function frame() {
        if (!dragging) {
          pos += (target - pos) * lerp;
          if (Math.abs(target - pos) < 0.4) pos = target;
        }
        envolver();
        aplicar();
        pintarPuntos();
        requestAnimationFrame(frame);
      }

      function actualizarPuntosVisibles() {
        if (!puntosWrap) return;
        // Con loop activo los puntos navegan; si todo entra en pantalla se ocultan.
        puntosWrap.style.display = activo() ? 'flex' : 'none';
      }

      function reiniciar() {
        medir();
        if (activo()) {
          pos = setW;
          target = setW;
        } else {
          pos = 0;
          target = 0;
        }
        aplicar();
        actualizarPuntosVisibles();
        idxActual = -1;
        pintarPuntos();
      }

      reiniciar();
      requestAnimationFrame(frame);
      setTimeout(reiniciar, 300);
      window.addEventListener('load', reiniciar);

      var reajuste;
      window.addEventListener('resize', function () {
        clearTimeout(reajuste);
        reajuste = setTimeout(reiniciar, 200);
      });

      function irNext() { medir(); target = Math.round(target / step) * step + step; }
      function irPrev() { medir(); target = Math.round(target / step) * step - step; }

      var prev = wrapper.querySelector('.uing-flecha--prev');
      var next = wrapper.querySelector('.uing-flecha--next');
      if (prev) prev.addEventListener('click', irPrev);
      if (next) next.addEventListener('click', irNext);

      // Navegacion manual con los puntitos.
      for (var d = 0; d < puntos.length; d++) {
        (function (idx) {
          puntos[idx].addEventListener('click', function () {
            medir();
            if (!activo()) return;
            var deseado = setW + idx * step;
            while (deseado - target > setW / 2) deseado -= setW;
            while (target - deseado > setW / 2) deseado += setW;
            target = deseado;
            pausado = true;
            setTimeout(function () { pausado = false; }, 4000);
          });
        })(d);
      }

      viewport.addEventListener('pointerdown', function (e) {
        down = true;
        dragging = false;
        startX = e.clientX;
        startY = e.clientY;
        startPos = pos;
        movido = 0;
        pausado = true;
      });

      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (!dragging) {
          if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
            dragging = true;
            pista.classList.add('uing-arrastrando');
            try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
          } else if (Math.abs(dy) > 8) {
            down = false;
            return;
          } else {
            return;
          }
        }
        pos = startPos - dx;
        target = pos;
        movido = Math.abs(dx);
      });

      function soltar() {
        if (!down) return;
        down = false;
        if (dragging) {
          dragging = false;
          pista.classList.remove('uing-arrastrando');
          medir();
          target = Math.round(pos / step) * step;
          if (movido > 6) {
            bloquear = true;
            setTimeout(function () { bloquear = false; }, 60);
          }
        }
        setTimeout(function () { pausado = false; }, 2000);
      }

      window.addEventListener('pointerup', soltar);
      window.addEventListener('pointercancel', soltar);

      viewport.addEventListener('click', function (e) {
        if (bloquear) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      wrapper.addEventListener('mouseenter', function () { pausado = true; });
      wrapper.addEventListener('mouseleave', function () { if (!down) pausado = false; });

      if (wrapper.dataset.autoplay === 'true') {
        var seg = parseFloat(wrapper.dataset.intervalo) || 5;
        setInterval(function () {
          if (pausado || down || !activo()) return;
          medir();
          target = Math.round(target / step) * step + step;
        }, seg * 1000);
      }
    }

    function init() {
      document.querySelectorAll('.uing-wrapper').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categorias-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activarArrastreMouse(pista) {
      var abajo = false, movido = false, xInicial = 0, scrollInicial = 0;

      pista.addEventListener('mousedown', function (e) {
        abajo = true;
        movido = false;
        pista.classList.add('mc-arrastrando');
        xInicial = e.pageX - pista.offsetLeft;
        scrollInicial = pista.scrollLeft;
      });

      pista.addEventListener('mouseleave', function () {
        abajo = false;
        pista.classList.remove('mc-arrastrando');
      });

      pista.addEventListener('mouseup', function () {
        abajo = false;
        pista.classList.remove('mc-arrastrando');
      });

      pista.addEventListener('mousemove', function (e) {
        if (!abajo) return;
        e.preventDefault();
        var x = e.pageX - pista.offsetLeft;
        var recorrido = (x - xInicial);
        if (Math.abs(recorrido) > 5) movido = true;
        pista.scrollLeft = scrollInicial - recorrido;
      });

      // Evita que un arrastre abra el enlace de la categoría
      pista.querySelectorAll('.menu-categorias-item').forEach(function (item) {
        item.addEventListener('click', function (e) {
          if (movido) {
            e.preventDefault();
            movido = false;
          }
        });
      });
    }

    function iniciarCarrusel(wrapper) {
      var pista = wrapper.querySelector('.menu-categorias-container');
      if (!pista) return;

      activarArrastreMouse(pista);

      if (wrapper.dataset.autoplay !== 'true') return;
      var items = pista.querySelectorAll('.menu-categorias-item');
      if (items.length < 2) return;

      var segundos = parseFloat(wrapper.dataset.intervalo) || 3;
      var timer = null;
      var pausado = false;

      function pasoScroll() {
        var estilo = getComputedStyle(pista);
        var gap = parseFloat(estilo.columnGap || estilo.gap) || 0;
        return items[0].offsetWidth + gap;
      }

      function avanzar() {
        if (pausado) return;
        var maxScroll = pista.scrollWidth - pista.clientWidth;
        if (pista.scrollLeft >= maxScroll - 4) {
          pista.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          pista.scrollBy({ left: pasoScroll(), behavior: 'smooth' });
        }
      }

      function arrancar() {
        detener();
        timer = setInterval(avanzar, segundos * 1000);
      }
      function detener() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      wrapper.addEventListener('mouseenter', function () { pausado = true; });
      wrapper.addEventListener('mouseleave', function () { pausado = false; });
      pista.addEventListener('touchstart', function () { pausado = true; }, { passive: true });

      arrancar();
    }

    function init() {
      document.querySelectorAll('.menu-categorias-wrapper').forEach(iniciarCarrusel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clientes-redes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(wrapper) {
      var cinta = wrapper.querySelector('.comu-cinta');
      var marquee = wrapper.querySelector('.comu-marquee');
      if (!cinta || !marquee) return;

      var grupo = marquee.querySelector('.comu-grupo');
      if (!grupo) return;

      function ajustarDuracion() {
        var vel = parseFloat(wrapper.dataset.velocidad) || 40;
        var ancho = grupo.scrollWidth || 1000;
        var dur = ancho / vel;
        if (dur < 8) dur = 8;
        marquee.style.setProperty('--comu-dur', dur.toFixed(1) + 's');
      }

      requestAnimationFrame(ajustarDuracion);
      setTimeout(ajustarDuracion, 400);
      window.addEventListener('load', ajustarDuracion);
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(ajustarDuracion, 200);
      });
    }

    function init() {
      document.querySelectorAll('.comu-wrapper').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["como-se-usa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CASCADE = 14; // separación del abanico cuando están apiladas

    function setup(wrapper) {
      var stack = wrapper.querySelector('.qs-fs-stack');
      if (!stack) return;
      var cards = Array.prototype.slice.call(stack.querySelectorAll('.qs-fs-card'));
      if (cards.length < 2) return; // con 1 carta no hay apilado

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var data = [];
      var ticking = false;

      function measure() {
        var base = cards[0].offsetTop;
        data = cards.map(function (card, i) {
          var rot = parseFloat(card.getAttribute('data-rot')) || 0;
          var rel = card.offsetTop - base;
          card.style.zIndex = String(i + 1);
          return { card: card, stacked: -(rel) + i * CASCADE, rot: rot };
        });
      }

      function apply(p) {
        var inv = 1 - p;
        for (var i = 0; i < data.length; i++) {
          var d = data[i];
          var y = inv * d.stacked;
          var r = inv * d.rot;
          d.card.style.transform =
            'translateY(' + y.toFixed(2) + 'px) rotate(' + r.toFixed(2) + 'deg)';
        }
      }

      function update() {
        ticking = false;
        if (reduce) { apply(1); return; }
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var rect = stack.getBoundingClientRect();
        // 0 = apiladas (entrando), 1 = desplegadas
        var p = ((vh * 0.80) - rect.top) / (vh * 0.55);
        p = Math.max(0, Math.min(1, p));
        apply(p);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      measure();
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measure(); update(); });
      window.addEventListener('load', function () { measure(); update(); });
    }

    function initAnim() {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.qs-fs-anim').forEach(function (el) { el.classList.add('qs-fs-visible'); });
        return;
      }
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('qs-fs-visible'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.2 });
      document.querySelectorAll('.qs-fs-anim').forEach(function (el) { obs.observe(el); });
    }

    function init() {
      initAnim();
      document.querySelectorAll('.qs-fs-wrapper').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var wrap = e.target.querySelector ? e.target.querySelector('.qs-fs-wrapper') : null;
      initAnim();
      if (wrap) setup(wrap); else document.querySelectorAll('.qs-fs-wrapper').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(wrapper) {
      var track = wrapper.querySelector('.prodp-track');
      var slides = wrapper.querySelectorAll('.prodp-slide');
      var minis = wrapper.querySelectorAll('.prodp-miniatura');
      var puntos = wrapper.querySelectorAll('.prodp-punto');

      function irA(idx) { if (track && slides[idx]) track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' }); }
      function marcar(idx) {
        minis.forEach(function (m, i) { m.classList.toggle('prodp-miniatura--activa', i === idx); });
        puntos.forEach(function (p, i) { p.classList.toggle('prodp-punto--activo', i === idx); });
      }
      function actual() {
        if (!track) return 0; var min = Infinity, idx = 0;
        slides.forEach(function (s, i) { var d = Math.abs(s.offsetLeft - track.scrollLeft); if (d < min) { min = d; idx = i; } });
        return idx;
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { irA(parseInt(m.getAttribute('data-idx'), 10)); }); });
      puntos.forEach(function (p) { p.addEventListener('click', function () { irA(parseInt(p.getAttribute('data-idx'), 10)); }); });
      if (track) track.addEventListener('scroll', function () { window.requestAnimationFrame(function () { marcar(actual()); }); }, { passive: true });
    }

    function init() { document.querySelectorAll('.prodp-wrapper').forEach(iniciar); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-destacadas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(wrapper) {
      var track = wrapper.querySelector('.resenas-fs-track');
      if (!track) return;
      var cards = track.querySelectorAll('.resenas-fs-card');
      if (cards.length < 1) return;

      var prev = wrapper.querySelector('.resenas-fs-flecha--prev');
      var next = wrapper.querySelector('.resenas-fs-flecha--next');
      var puntosCont = wrapper.querySelector('.resenas-fs-puntos');

      if (puntosCont && cards.length > 1) {
        cards.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'resenas-fs-punto' + (i === 0 ? ' resenas-fs-punto--activo' : '');
          b.setAttribute('aria-label', 'Reseña ' + (i + 1));
          b.addEventListener('click', function () {
            track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          });
          puntosCont.appendChild(b);
        });
      }
      var puntos = puntosCont ? puntosCont.querySelectorAll('.resenas-fs-punto') : [];

      function indiceActual() {
        var min = Infinity, idx = 0;
        cards.forEach(function (c, i) {
          var d = Math.abs(c.offsetLeft - track.scrollLeft - track.offsetLeft);
          if (d < min) { min = d; idx = i; }
        });
        return idx;
      }

      function marcar() {
        var idx = indiceActual();
        puntos.forEach(function (p, i) {
          p.classList.toggle('resenas-fs-punto--activo', i === idx);
        });
      }

      function irA(i) {
        var total = cards.length;
        var idx = (i + total) % total;
        track.scrollTo({ left: cards[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { irA(indiceActual() - 1); });
      if (next) next.addEventListener('click', function () { irA(indiceActual() + 1); });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(marcar);
      }, { passive: true });

      var pausado = false;
      wrapper.addEventListener('mouseenter', function () { pausado = true; });
      wrapper.addEventListener('mouseleave', function () { pausado = false; });
      track.addEventListener('touchstart', function () { pausado = true; }, { passive: true });
      track.addEventListener('touchend', function () {
        setTimeout(function () { pausado = false; }, 4000);
      }, { passive: true });

      if (wrapper.dataset.autoplay === 'true' && cards.length > 1) {
        var seg = parseFloat(wrapper.dataset.intervalo) || 5;
        setInterval(function () {
          if (pausado) return;
          irA(indiceActual() + 1);
        }, seg * 1000);
      }
    }

    function init() {
      document.querySelectorAll('.resenas-fs-wrapper').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-foto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(wrapper) {
      var track = wrapper.querySelector('.resec-fs-track');
      if (!track) return;
      var cards = track.querySelectorAll('.resec-fs-card');
      if (!cards.length) return;

      var prev = wrapper.querySelector('.resec-fs-flecha--prev');
      var next = wrapper.querySelector('.resec-fs-flecha--next');
      var puntosCont = wrapper.querySelector('.resec-fs-puntos');

      if (puntosCont && cards.length > 1 && !puntosCont.children.length) {
        cards.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'resec-fs-punto' + (i === 0 ? ' resec-fs-punto--activo' : '');
          b.setAttribute('aria-label', 'Resena ' + (i + 1));
          b.addEventListener('click', function () {
            track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          });
          puntosCont.appendChild(b);
        });
      }
      var puntos = puntosCont ? puntosCont.querySelectorAll('.resec-fs-punto') : [];

      function indiceActual() {
        var min = Infinity, idx = 0;
        cards.forEach(function (c, i) {
          var d = Math.abs(c.offsetLeft - track.scrollLeft - track.offsetLeft);
          if (d < min) { min = d; idx = i; }
        });
        return idx;
      }
      function marcar() {
        var idx = indiceActual();
        puntos.forEach(function (p, i) { p.classList.toggle('resec-fs-punto--activo', i === idx); });
      }
      function irA(i) {
        var total = cards.length;
        var idx = (i + total) % total;
        track.scrollTo({ left: cards[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { irA(indiceActual() - 1); });
      if (next) next.addEventListener('click', function () { irA(indiceActual() + 1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(marcar); }, { passive: true });

      var pausado = false;
      wrapper.addEventListener('mouseenter', function () { pausado = true; });
      wrapper.addEventListener('mouseleave', function () { pausado = false; });
      track.addEventListener('touchstart', function () { pausado = true; }, { passive: true });
      track.addEventListener('touchend', function () { setTimeout(function () { pausado = false; }, 4000); }, { passive: true });

      if (wrapper.dataset.autoplay === 'true' && cards.length > 1) {
        var seg = parseFloat(wrapper.dataset.intervalo) || 5;
        setInterval(function () { if (!pausado) irA(indiceActual() + 1); }, seg * 1000);
      }

      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('resec-fs-visible'); obs.unobserve(e.target); }
          });
        }, { threshold: 0.15 });
        wrapper.querySelectorAll('.resec-fs-anim').forEach(function (el) { obs.observe(el); });
      } else {
        wrapper.querySelectorAll('.resec-fs-anim').forEach(function (el) { el.classList.add('resec-fs-visible'); });
      }
    }

    function init() {
      document.querySelectorAll('.resec-fs-wrapper').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
